<template>
  <div
    class="international_container"
    :style="{ width: containerWidth, 'min-width': containerWidth }"
  >
    <div class="international_content">
      <div class="selected_box" @click="reverseSubMenu = !reverseSubMenu">
        <div v-show="isCountryName" class="country_name">
          {{ currentCountryData.name }}
        </div>
        <div v-show="isCountryDialCode" class="country_code">
          {{ currentCountryData.areaCode }}
        </div>
        <div class="arrow_icon">
          <img class="full_img" src="./../../assets/images/icon-xiala4.png" />
        </div>
      </div>
      <ul class="country_list" v-show="reverseSubMenu">
        <li
          class="each_country"
          v-for="item in countryList"
          :key="item.id"
          :class="item.id == currentCountryID ? 'selected' : ''"
          @click="setCountry(item)"
        >
          <span class="country_name">{{ item.name }}</span>
          <span class="international_code">{{ item.areaCode }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { registerCountryList } from '@/api/sign'
export default {
  name: 'InternationalCode',
  props: {
    containerWidth: {
      type: String,
      default: '100%'
    },
    defaultCountryID: {
      type: Number,
      default: process.env.VUE_APP_OUTPUTDIR === 'production' ? 51 : 51 // 默认国家ID
    },
    isCountryName: {
      type: Boolean,
      default: false
    },
    isCountryDialCode: {
      type: Boolean,
      default: false
    },
    countryLangAbridge: {
      type: [String, Number],
      default: 'zh-CN' // 默认国家：中国
    },
    countryDialCode: {
      type: [String, Number],
      default: 86 // 默认国家：中国
    }
  },
  data() {
    return {
      reverseSubMenu: false,
      currentCountryID: this.defaultCountryID,
      currentCountryData: {}, // 保存默认 或者 当前选中的国家数据
      countryList: {} // 保存最终国家列表数据
    }
  },
  created() {
    this.getCanRegisterCountry().then(() => {
      this.$emit('selectCountry', this.getCountryDataObj(this.defaultCountryID))
      this.$emit(
        'update:countryLangAbridge',
        this.getCountryDataObj(this.defaultCountryID).language
      )
      this.$emit(
        'update:countryDialCode',
        this.getCountryDataObj(this.defaultCountryID).areaCode
      )
    })
  },
  watch: {
    currentCountryID(newVal) {
      this.currentCountryData = this.getCountryDataObj(newVal)
    }
  },
  methods: {
    async getCanRegisterCountry() {
      const data = await registerCountryList()
      this.countryList = data
      this.currentCountryData = this.getCountryDataObj(this.defaultCountryID)
    },
    setCountry(item) {
      this.reverseSubMenu = false
      this.currentCountryID = item.id
      this.$emit('selectCountry', item)
      this.$emit('update:countryLangAbridge', item.language)
      this.$emit('update:countryDialCode', item.areaCode)
    },
    getCountryDataObj(id) {
      for (const obj of this.countryList) {
        if (obj.id === id) {
          return obj
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import 'index.less';
.international_container {
  position: relative;
  width: 100%;
  height: 40px;
  color: #666;
  font-size: 14px;
  .international_content {
    height: 100%;
    cursor: pointer;
    .selected_box {
      position: relative;
      padding: 0px 10px;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      border: 1px solid #999999;
      border-radius: 4px;
      font-size: 18px;
      font-weight: 400;
      color: #333333;
      overflow: hidden;
      .country_name {
        white-space: nowrap;
      }
      .country_code,
      .country_flag {
        margin-left: 6px;
      }
      .arrow_icon {
        position: absolute;
        right: 5px;
        width: 30px;
        height: 30px;
        .full_img {
          vertical-align: top;
        }
      }
    }
  }
  .country_list {
    width: 380px;
    height: 400px;
    line-height: normal;
    margin-top: 2px;
    position: absolute;
    z-index: 2;
    list-style: none;
    text-align: left;
    padding: 0;
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
    background-color: white;
    border: 1px solid #ccc;
    white-space: nowrap;
    max-height: 500px;
    overflow-y: scroll;
    .each_country {
      padding: 10px 15px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      &.selected {
        color: #fff;
        background-color: #ff6a6a;
        .international_code {
          color: #fff;
        }
      }
      &:not(.selected):hover {
        color: #fff;
        background-color: #41b883;
        .international_code {
          color: #fff;
        }
      }
    }
    .country_flag_box,
    .country_name {
      margin-right: 6px;
    }
    .country_flag_box,
    .country_name,
    .international_code {
      vertical-align: middle;
    }
    .country_flag_box {
      display: inline-block;
      width: 20px;
    }
    .international_code {
      color: #999;
    }
  }
}
</style>
